import { render } from "./AuthOfficialBusinessStatusTracker.vue?vue&type=template&id=2f2ef7a7&scoped=true"
import script from "./AuthOfficialBusinessStatusTracker.vue?vue&type=script&lang=js"
export * from "./AuthOfficialBusinessStatusTracker.vue?vue&type=script&lang=js"

import "./AuthOfficialBusinessStatusTracker.vue?vue&type=style&index=0&id=2f2ef7a7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2ef7a7"]])

export default __exports__